import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class EditKundorderCommand extends BasicCommand<EditKundorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<EditKundorderCommand>;
    kundorderId: number;
    avtalansvarigId: number;
    beskrivning: string;

    constructor(kundorderId: number) {
        super("EditKundorderCommand", "kundorderrad", CommandType.Delete);
        this.kundorderId = kundorderId;
    }

}
